import { query } from '@confluence/query-preloader-tools';

import { ModernizedBreadcrumbsQuery } from './ModernizedBreadcrumbsQuery.graphql';

export function preloadBreadcrumbsDropdown({
	spaceKey,
	contentId,
}: {
	spaceKey: string;
	contentId?: string;
}) {
	return query({
		query: ModernizedBreadcrumbsQuery,
		variables: {
			spaceKey,
			contentId,
			skipContent: !contentId,
		},
	});
}
